<template>
  <Breadcrumbs title="Institución" />

  <div class="container-fluid">
    <div class="email-wrap bookmark-wrap">
      <div class="row">
        <div class="col-xl-3 col-md-12 col-12">
          <div>
            <div>
              <div class="card">
                <div class="card-body">
                  <div class="email-app-sidebar left-bookmark">
                    <ul class="nav main-menu contact-options" role="tablist">
                      <newContact
                        :statusEnrollment="statusEnrollment"
                        :departments="departments"
                        @selectSchool="changeSchool"
                        @getReport="generateReport"
                      />
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-md-12 box-col-12">
          <div class="email-right-aside bookmark-tabcontent contacts-tabs">
            <div class="card email-body radius-left">
              <div class="ps-0">
                <div class="tab-content">
                  <div
                    class="tab-pane fade"
                    v-bind:class="
                      activeclass === 'pills-personal-tab' ? 'active show' : ''
                    "
                    id="pills-personal"
                    role="tabpanel"
                    aria-labelledby="pills-personal-tab"
                  >
                    <personalContact
                      :students="listStudent"
                      :institution="institutionSelected"
                      :participantList="participantList"
                      :participantSelected="participantSelected"
                      :statusEnrollment="statusEnrollment"
                      :selectedDepartment="selectedDepartment"
                      @changeStatusEnrollment="getStatusEnrollment"
                      @selectSchool="changeSchool"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-show="false">
    <div class="report" ref="reportEnrollment">
      <!-- Header Section -->
      <div class="report-header">
        <div class="header-content">
          <img
            src="@/assets/minedu.png"
            alt="Ministerio de Educación Logo"
            class="logo"
          />
          <div class="header-text">
            <h1 class="ministry-name">MINISTERIO DE EDUCACIÓN</h1>
            <h2 class="report-title">
              REPORTE DE PARTICIPANTES CLASIFICADOS - FASE DEPARTAMENTAL
            </h2>
            <h3 class="event-title">
              4TO. ENCUENTRO DE ESTUDIANTES CON PRODUCTOS, HABILIDADES Y TALENTO
              EXTRAORDINARIO EN EL SISTEMA EDUCATIVO PLURINACIONAL "DESCUBRIENDO
              TALENTOS" - GESTIÓN 2025
            </h3>
          </div>
        </div>
      </div>

      <!-- District Info -->
      <div class="district-info">
        <div class="info-container">
          <div class="info-item">
            <span class="info-label">CÓDIGO DEPARTAMENTO:</span>
            <span class="info-value">{{ distritName }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">GESTIÓN:</span>
            <span class="info-value">2025</span>
          </div>
        </div>
      </div>

      <!-- Participants Table -->
      <div class="table-container">
        <table class="participants-table">
          <thead>
            <tr>
              <th class="col-number">N°</th>
              <th class="col-name">NOMBRES Y APELLIDOS</th>
              <th class="col-rude">NRO. RUDE</th>
              <th class="col-id">NRO. CARNET</th>
              <th class="col-birthdate">FECHA NACIMIENTO</th>
              <th class="col-age">EDAD</th>
              <th class="col-area">ÁREA O SUBÁREA</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(participant, index) in listStudent"
              :key="participant.carnet"
              :class="{
                'even-row': index % 2 === 0,
                'odd-row': index % 2 !== 0,
              }"
            >
              <td class="text-center">{{ index + 1 }}</td>
              <td>
                {{ participant.nombre }} {{ participant.paterno }}
                {{ participant.materno }}
              </td>
              <td class="text-center">{{ participant.codigo_rude }}</td>
              <td class="text-center">
                {{ participant.carnet_identidad }} {{ participant.complemento }}
              </td>
              <td class="text-center">
                {{ formatDate(participant.fecha_nacimiento) }}
              </td>
              <td class="text-center">
                {{ calculateAge(participant.fecha_nacimiento) }}
              </td>
              <td>{{ participant.area }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Footer Section -->
      <div class="report-footer">
        <div class="declaration">
          <p>
            El presente documento, constituye una Declaración Jurada sobre los
            datos del estudiante/participante clasificados de la Fase
            Departamental.
          </p>
        </div>

        <div class="signature-section">
          <div class="signature-line"></div>
          <div class="signature-label">
            Sello y Firma del Director/a Departamental de Educación
          </div>
        </div>

        <div class="note">
          <p>
            <strong>Nota:</strong> *El registro de los nombres de las y los
            estudiantes/participantes clasificados debe realizarse sin tener
            sobrescritos.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import newContact from "./newContact.vue";
import personalContact from "./personalContact.vue";
import { onMounted, ref, computed } from "vue";
import axios from "@/includes/connection";

import html2pdf from "html2pdf.js";
const reportEnrollment = ref(null);

import { toast } from "vue3-toastify";

const selectInstitution = ref({ institucioneducativa_tipo_id: 1 });

onMounted(async () => {
  // changeSchool();
  // getStatusEnrollment();
  await getDepartments();
});

//---  department section
const departments = ref([]);
const getDepartments = () => {
  axios
    .get("/institution/list-departments/show")
    .then((response) => {
      console.log("departments", response.data);
      departments.value = response.data;
    })
    .catch(function (error) {
      toast.error("Falla al conectar con el server.");
    });
};

let institutionSelected = ref({});
const listStudent = ref([]);
const selectedDepartment = ref(null);

function changeSchool(deptoId) {
  console.log("changeSchool", deptoId);
  selectedDepartment.value = departments.value.find(
    (dept) => dept.id === deptoId
  );
  console.log("selectedDepartment", selectedDepartment.value);
  // get student enrolled
  axios
    .get("/enrollment-list/list-by-department/" + deptoId)
    .then((response) => {
      console.log("out ", response.data);
      listStudent.value = response.data;
    })
    .catch(function (error) {
      toast.error("Falla al conectar con el server.");
    });
}

// --------------------------refactor

const activeclass = ref("pills-personal-tab");
const filtered = ref(false);

function active(item) {
  activeclass = item;
}

const participantList = ref([]);

function changeStatus(status) {
  statusEnrollment.value = status;
  console.log("status", status);
}

// disabled phase
const statusEnrollment = ref();
function getStatusEnrollment() {
  axios
    .post("/institution/is-consolidate-distrital", {
      user: localStorage.getItem("username"),
    })
    .then((response) => {
      console.log("response", response);
      statusEnrollment.value = response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
}

// -------------------------- selected students
const participantSelected = ref([]);
function getParticipantSelected(ins) {
  axios
    .get("/enrollment-list/saved/distrital/" + ins)
    .then((response) => {
      console.log("getParticipantSelected", response.data);
      participantSelected.value = response.data;

      participantList.value = participantSelected.value.map((el) => {
        return el.participant_id;
      });
      console.log("list", participantList.value);
    })
    .catch(function (error) {
      console.log(error);
    });
}

//--- report section

const participantEnrolled = ref();

const distritName = ref(localStorage.getItem("place"));

const districtId = ref();

const generateReport = async () => {
  await changeSchool();
  html2pdf(reportEnrollment.value, {
    margin: 1,
    filename: districtId.value + ".pdf",
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
  }).from(() => {
    const pdf = document.querySelector(".html2pdf");
    const pdfBlob = pdf2blob(pdf);
    const pdfUrl = URL.createObjectURL(pdfBlob);
    const downloadLink = document.createElement("a");
    downloadLink.href = pdfUrl;
    downloadLink.download = "reporte_clasificados_distrital.pdf";
    downloadLink.click();
  });
};

function pdf2blob(pdf) {
  const pdfData = new Blob([pdf.outerHTML], { type: "application/pdf" });
  return pdfData;
}

// Utility functions
const formatDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

const calculateAge = (birthDate) => {
  if (!birthDate) return "";

  const today = new Date();
  const birth = new Date(birthDate);
  if (isNaN(birth.getTime())) return "";

  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }

  return age;
};
</script>

<style scoped>
.report {
  font-family: "Arial", sans-serif;
  max-width: 215.9mm; /* US Letter width (8.5 inches) */
  /* Alternatively: max-width: 8.5in; */
  margin: 0 auto;
  padding: 2mm;
  color: #333;
  line-height: 1.4;
}
/* Header Styles */
.report-header {
  text-align: center;
  margin-bottom: 20px;
  border-bottom: 2px solid #1a3e72;
  padding-bottom: 15px;
}

.header-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 15px;
}

.header-text {
  margin-top: 50px;
}

.logo {
  height: 60px;
  margin-bottom: 10px;
}

.ministry-name {
  font-size: 18px;
  font-weight: bold;
  color: #1a3e72;
  margin: 5px 0;
}

.report-title {
  font-size: 16px;
  font-weight: bold;
  color: #1a3e72;
  margin: 5px 0 10px;
}

.event-title {
  font-size: 14px;
  font-weight: normal;
  color: #333;
  margin: 5px 0;
}

/* District Info Styles */
.district-info {
  margin: 15px 0;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.info-container {
  display: flex;
  justify-content: space-between;
}

.info-item {
  display: flex;
  align-items: center;
}

.info-label {
  font-weight: bold;
  margin-right: 5px;
}

.info-value {
  color: #1a3e72;
}

/* Table Styles */
.table-container {
  margin: 20px 0;
  overflow-x: auto;
}

.participants-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.participants-table th {
  background-color: #1a3e72;
  color: white;
  padding: 8px;
  text-align: center;
  font-weight: bold;
}

.participants-table td {
  padding: 8px;
  border: 1px solid #ddd;
}

.participants-table tr.even-row {
  background-color: #f9f9f9;
}

.participants-table tr.odd-row {
  background-color: white;
}

.participants-table tr:hover {
  background-color: #f1f1f1;
}

.text-center {
  text-align: center;
}

/* Footer Styles */
.report-footer {
  margin-top: 30px;
  font-size: 12px;
}

.declaration {
  margin-bottom: 30px;
  text-align: justify;
}

.signature-section {
  margin: 120px 0 30px;
  text-align: center;
}

.signature-line {
  border-top: 1px solid #333;
  width: 60%;
  margin: 0 auto 5px;
}

.signature-label {
  font-weight: bold;
}

.note {
  font-style: italic;
  color: #666;
  width: 100%;
  max-width: 100%;
  min-height: auto !important;
  margin: 20px 0 0 0;
  padding: 0;
}

.note p {
  margin: 0;
  padding: 5px;
  text-align: left;
  width: 100%;
}

/* Print-specific styles */
@media print {
  .report {
    padding: 0;
    width: 100%;
  }

  .report-header {
    page-break-after: avoid;
  }

  .participants-table {
    page-break-inside: avoid;
  }

  .signature-section {
    page-break-before: avoid;
  }
}
</style>
